var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"full-input-size"}},[_c('NxInput',{attrs:{"name":"nome","type":"text","label":"Cooperativa:","placeholder":"Digite o nome da cooperativa","value":_vm.localValue},on:{"update:value":_vm.handleValueUpdate}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5061184b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nexum/components/custom-inputs/NxInputCooperativa.vue
// module id = null
// module chunks = 